module.exports = __webpack_public_path__ + "img/icon_avatar@3x.ef10ae42.png";